import { useTranslation } from "react-i18next"
import { IoTable, Overlay, PageHeader, SystemSettings } from "../../../../Components"
import { colors, frames } from "../../../../Styles"
import { Pages } from "../../../../Navigation/root"
import { useSelector } from "react-redux"
import { RootState, useAppSelector } from "../../../../Store"
import { useEffect, useMemo } from "react"
import { Graph_QL, useDeviceInfo, useSystem } from "../../../../Services"
import { useParams } from "react-router"
import { useSystemInfoById } from "../../../../Services/Agrisys_GqlDataCaller/SystemCalls/systemSlice"

const SYSTEM_ID = 1;

export default function Freeda_esf_settings() {
  const { t } = useTranslation()
  const { systemId: urlSystemId } = useParams(); // TODO routing changes in order to get a correct system info
  const systemId = urlSystemId ? +urlSystemId : SYSTEM_ID;

  // Edit Mode States
  const editMode = useSelector((state: RootState) => state.uiState.editMode.editMode);

  // #region | GraphQL
  const farm = useAppSelector(({ activeData }) => activeData.farm) ?? "";
  const domain = useMemo(() => Graph_QL.ObjToString({ domain: farm }), [farm]);
  const connection = useMemo(() => Graph_QL.create({ domain: farm }), [farm]);

  const { data: deviceInfoState, call: getDeviceInfo, maintainEntries: maintainDeviceInfo } = useDeviceInfo(connection);
  
  useEffect(() => {
    getDeviceInfo({ fetchAmount: 500 }, connection);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [connection]);
  
  
  const {isLoading, entity: system} = useSystemInfoById(systemId)
    
  const deviceInfo = useMemo(() => { if (deviceInfoState[domain]) { return deviceInfoState[domain].data.filter((device) => device?.system_assignment === systemId ) } return [] }, [deviceInfoState, domain, systemId]);
  // #endregion

  // Seperator
  const seperator = <div style={{ width: "95%", height: "2px", borderTop: "2px solid " + colors.greyDarkPrimary }} />
  
  return (<>
    <frames.Page_inner>
        {editMode ? <Overlay overrides={{ }} beforeUnload onClickAlert /> : <></>}
        <PageHeader
          topHeader={system?.name}
          subHeader={t(`menuHeaders.${Pages.freeda_esf_settings}`, {defaultValue: "settings"})}
        />
        <frames._page_inner_content_scroll>
          <div style={{ display: "flex", gap: "20px", alignItems: "center", justifyContent: "center", flexDirection: "column"}} >
            <SystemSettings />
            {seperator}
            <IoTable deviceInfo={deviceInfo} maxTableHeight="400px" showSystemRow={false} maintainDeviceInfo={maintainDeviceInfo} />
          </div>
      </frames._page_inner_content_scroll>
    </frames.Page_inner>
  </>)
}